import React from 'react'
import {createUseStyles} from 'react-jss'

import {largeHeight} from '../header/style'

const useStyles = createUseStyles(theme => ({
	main: {
		flexGrow: '1',
		position: 'relative',
		boxShadow: '0px 8px 8px #00000030',
		borderRadius: '10px 10px 0px 0px',
		minHeight: '800px',
		paddingBottom: '30px',
		backgroundColor: '#fff',
	},
	headerContainer: {
		margin: '0 -10px',
		position: 'sticky',
		backgroundColor: theme.colors.background,
		display: 'block',
		padding: '30px 10px 0',
		'&$show': {
			display: 'block',
			marginTop: '30px',
			'@media screen and (min-width: 768px)': {
				marginTop: 'inherit',
			},
		},
		// '@media screen and (min-width: 992px)': {
		// 	top: `${largeHeight + 1}px`,
		// },
		// '@media screen and (min-width: 1200px)': {
		// 	top: `${largeHeight + 11}px`,
		// },
		zIndex: '3',
		'&$hidden': {
			zIndex: '-1',
		},
		'&$top': {
			zIndex: '1',
			'& > * > *': {
				opacity: '0',
			},
		},
		'& h1': {
			color: '#fff',
			fontWeight: theme.fontWeight.normal,
			// padding: '6px 0 0',
		},
		'& p': {
			padding: '2px 0 0',
			fontSize: '12px',
			'@media screen and (min-width: 768px)': {
				fontSize: '14px',
			},
		},
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '10px 20px 10px 20px',
		'@media screen and (min-width: 768px)': {
			padding: '10px 30px 10px 60px',
		},
		backgroundColor: '#123456',
		color: '#fff',
		boxShadow: '0px 2px 10px #00000048',
		borderRadius: '10px 10px 0px 0px',
		height: '68px',
		overflow: 'visible',
		'&$hidden': {
			overflow: 'hidden',
			backgroundColor: 'transparent',
		},
	},
	content: {
		padding: '0 10px',
		'@media screen and (min-width: 768px)': {
			padding: '0 20px',
		},
		'@media screen and (min-width: 992px)': {
			padding: '0 30px',
		},
		'@media screen and (min-width: 1200px)': {
			padding: '0 40px',
		},
	},
	title: {
		fontSize: '18px',
		'@media screen and (min-width: 768px)': {
			fontSize: '22px',
		},
		'@media screen and (min-width: 992px)': {
			fontSize: '26px',
		},
		'@media screen and (min-width: 1200px)': {
			fontSize: '28px',
		},
	},
}));

const TitledTab = ({children, title, className, ...restProps}) => {
	const classes = useStyles();

	return (
		<div className={classes.main}>
			<div className={classes.headerContainer}>
				<div className={classes.header}>
					<h1 className={classes.title}>{title}</h1>
				</div>
			</div>
			<div className={classes.content}>
				{children}
			</div>
		</div>
	);
};

export default TitledTab;
